export default __webpack_public_path__ + "static/media/facadehigh.a906f327.jpg";